import React, {useEffect, useState } from "react";
import Button from "../../components/common/Button";
import moment from "moment";
import Input from "../../components/common/Input";
import Radio from "../../components/common/Radio";
import Jumpbotron from "../../components/common/Jumpbotron";
import Select from "../../components/common/Select";
import InputPicker from "../../components/common/InputPicker";
import Modal from "../../components/common/Modal";
import DatosProveedor from "../../components/common/DatosProveedor";
import Tab from "../../components/common/Tab";
import { useDispatch } from "react-redux";
import { initDataProveedorAccionista_Ex,initDataProveedorAccionistaArray_Ex,
  initDataProveedorAccionista_Val,initDataProveedorAccionistaArray_Val} from "../../utils/options";
import CustomTable from "../../components/CustomTable";
import TableRimac from "../../components/common/Table/TableRimac";
import { hideLoading, showLoading } from "../../redux/actions/general";
import { headDataUsers } from "../../components/CustomTable/headData";
import usersData from "../../components/CustomTable/usersData";
import addUserIcon from "../../assets/icon_add_user.svg";
import editUserIcon from "../../assets/gl_edit_16.svg";
import chevrotIcon from "../../assets/chevrot.svg";
import chevrotIconUp from "../../assets/gl_arrow_up.svg";
import chevrotIconDown from "../../assets/gl_arrow_down.svg";
import deleteLogo from "../../assets/gl_delete-20.svg";
import "./styles.scss";
//import { Checkbox } from "aws-amplify-react";
import { callService } from "../../amplify/callService";
import { CONSTANTES } from "../../utils/Constantes";
import Alert from "../../components/common/Alert";
import { getColorByStatusFlag } from "../../utils/utils";
import { iconEdit, iconCheck } from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import Pagination from "../../components/common/Pagination";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import Checkbox from "../../components/common/Checkbox";
import Validate from "../../utils/Validate";

const ProveedoresAccionista = ({dataT, keyIndex, handleActualizarFicha, handleChangePaso}) => {
  const dispatch = useDispatch();

  const [openAdd, setOpenAdd] = useState(false);
  const [tagBody, setTagBody] = useState("nostate");  
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });
  const [arrPerfiles, setArrPerfiles] = useState([]);
  const [arrPais, setArrPais] = useState([]);
  const [arrDepartamento, setarrDepartamento] = useState([]);
  const [arrProvincia, setArrProvincia] = useState([]);
  const [arrDistrito, setArrDistrito] = useState([]);
  const [arrTipoDoc, setArrTipoDoc] = useState([]);
  const [arrMoneda , setArrMoneda] = useState([]);
  const [dataTemp, setDataTemp] = useState({});
  const [validacionTemp, setValidacionTemp] = useState({});
  const [infoModal, setInfoModal] = useState(null);
  const [indVmAcc, setIndVmAcc] = useState(false);
  const [data, setData] = useState(Validate.extraerAtributos(initDataProveedorAccionista_Ex, dataT, initDataProveedorAccionistaArray_Ex));
  const [validacion, setValidacion] = useState({accionista:[]});
  const [indiceEditar, setIndiceEditar] = useState(null);
  useEffect(() => {    
    setData(Validate.extraerAtributos(initDataProveedorAccionista_Ex, dataT, initDataProveedorAccionistaArray_Ex));
  }, [dataT]);

  useEffect(() => {    
    getMonedas();
    getTipoDoc();
    getPaises();
  }, []);  
  let arrSN=[{value:'S',text:'SI'},{value:'N',text:'NO'}];
  const getMonedas = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','MONEDA'));
      if (response.ok && response.data && response.data.payload) {
        let monedas = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrMoneda(monedas);
      }
    } catch (ex) {
      console.log("Error al obtener getMonedas", ex);
    }
  };
  const getTipoDoc = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','TIPDOC'));
      if (response.ok && response.data && response.data.payload) {
        let tipdoc = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrTipoDoc(tipdoc);
      }
    } catch (ex) {
      console.log("Error al obtener tipdoc", ex);
    }
  };
  const getPaises = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarPaises);
      if (response.ok && response.data && response.data.payload) {
        let paises = response.data.payload.map((el, index) => {
          return {
            value: el.idpais,
            text: el.descpais
          };
        });
        setArrPais(paises);
      }
    } catch (ex) {
      console.log("Error al obtener getPaises", ex);
    }
  };
  const handleChange = (name, value, i) => {
    let jsonAd = {};    
    value = value.toUpperCase ? value.toUpperCase() : value;
    setData({ ...data, [name]: value });
    if(value instanceof Array){
      //let limpArr = Validate.limpiarArregloIdProveedor(value.map((obj) => Object.assign({},obj)));
      validacion[name][i]=false;
      setValidacion({ ...validacion, [name]: validacion[name]});
    }else{
      setValidacion({ ...validacion, [name]: false });
    }
    
  };
  const handleChangeTemp = (name, value) => {    
    value = value.toUpperCase ? value.toUpperCase() : value;
    setDataTemp({ ...dataTemp, [name]: value });
    setValidacionTemp({ ...validacionTemp, [name]: false });
  };
  const validarFormulario = () => {
    let resp = true;
    if(dataTemp.idpTipoDocumento=='RUC' || dataTemp.idpTipoDocumento=='DOT' ){
      delete initDataProveedorAccionistaArray_Val.indPep;
      delete initDataProveedorAccionistaArray_Val.cargo;
      delete initDataProveedorAccionistaArray_Val.aniosCargo;
      delete initDataProveedorAccionistaArray_Val.idPais;
      delete initDataProveedorAccionistaArray_Val.idResPais;
      delete initDataProveedorAccionistaArray_Val.fecNacimiento;
      delete initDataProveedorAccionistaArray_Val.profesion;
      delete initDataProveedorAccionistaArray_Val.direccion;
      delete initDataProveedorAccionistaArray_Val.telefono;
      delete initDataProveedorAccionistaArray_Val.correo;
    }else{
      if(dataTemp.indPep=='N'){
        delete initDataProveedorAccionistaArray_Val.cargo;
        delete initDataProveedorAccionistaArray_Val.aniosCargo;
      }else{
        initDataProveedorAccionistaArray_Val.cargo= "";
        initDataProveedorAccionistaArray_Val.aniosCargo= "";
      }
      if(dataTemp.telefono){
        delete initDataProveedorAccionistaArray_Val.correo;
        initDataProveedorAccionistaArray_Val.telefono= "";
      }else{
        initDataProveedorAccionistaArray_Val.correo= "";
        delete initDataProveedorAccionistaArray_Val.telefono;
      }
      initDataProveedorAccionistaArray_Val.indPep = "";
      initDataProveedorAccionistaArray_Val.idPais= "";
      initDataProveedorAccionistaArray_Val.idResPais= "";
      initDataProveedorAccionistaArray_Val.fecNacimiento= "";
      initDataProveedorAccionistaArray_Val.profesion= "";
      initDataProveedorAccionistaArray_Val.direccion= "";
      //initDataProveedorAccionistaArray_Val.telefono= "";
      //initDataProveedorAccionistaArray_Val.correo= "";
    }
    for (var name in Object.assign({},initDataProveedorAccionistaArray_Val,Validate.limpiarObjeto(dataTemp))) {
      //if (data.hasOwnProperty(name)){
        if(!dataTemp[name] ){
          validacionTemp[name] = true;
          setValidacionTemp({...validacionTemp, [name]: true});
          resp = false;
          //break;
        }
        if(name=='correo' && !Validate.validarEmail(dataTemp[name])){
          validacionTemp[name] = true;
          setValidacionTemp({...validacionTemp, [name]: true});
          resp = false;
        } 
        if(name=='numeroDocumento' && !Validate.validarDocumento(dataTemp.idpTipoDocumento,dataTemp[name])){
          validacionTemp[name] = true;
          setValidacionTemp({...validacionTemp, [name]: true});
          resp = false;
        }
        if(name=='prcCapital' && !Validate.validarPorcentaje(dataTemp[name])){
          validacionTemp[name] = true;
          setValidacionTemp({...validacionTemp, [name]: true});
          resp = false;
        } 
      //}     
    }
    return resp;
  }

  const validarFormularioGeneral = () => {
    let resp = true;
    for (var name in Object.assign({},initDataProveedorAccionista_Val,Validate.limpiarObjeto(data))) {
      //if (data.hasOwnProperty(name)){
        if(!data[name] ){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
          //break;
        }
        /*if(data[name] instanceof Array){
          let limpArr = Validate.limpiarArregloIdProveedor(data[name]);
          data[name] = limpArr.arr;
          if(limpArr.delete.length>0)
            data[name+'Delete'] = limpArr.delete;
          let i=0;
          for(let elem of data[name]){
            for (var name2 in Object.assign({},initDataProveedorAccionistaArray_Val,Validate.limpiarObjeto(elem))) {
              //if (elem.hasOwnProperty(name2)){
                if(!elem[name2]){
                  console.log("LOGG"+(validacion[name]));
                  (validacion[name])[i] = (validacion[name])[i]?(validacion[name])[i]:{};
                  ((validacion[name])[i])[name2] = true;
                  setValidacion({...validacion, [name]: validacion[name]});
                  resp = false;
                } 
              //}             
            }
            i++;
          }
        }*/
        if(data[name] instanceof Array){
          let limpArr = Validate.limpiarArregloIdProveedor(data[name]);
          data[name] = limpArr.arr;
          if(limpArr.delete.length>0)
            data[name+'Delete'] = limpArr.delete;
          let i=0;
          for(let elem of data[name]){
            if(elem.prcCapital)
              elem.prcCapital=Number(elem.prcCapital);
            if(elem.aniosCargo)
              elem.aniosCargo=Number(elem.aniosCargo);
          }
        }
      //}     
    }
    return resp;
  }

  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };
  
  const resetForm =() => {
    
  };

  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);
 

  const handleCloseModal = (value) => {
    setOpenAdd(value);
  };

  const handleChangeEnvioCorreo = (event) => {
    console.log('============', event)
  };

  const handleChangeEmail = (text) => {
    console.log('============', text);
    };


  const handleOpenAddModal = (tag) => {    
    setTagBody(tag);
    resetForm();
    setOpenAdd(true);
  };

  const handleShowModal = (tag) => {
    setTagBody(tag);
    setInfoModal(true);
  };

  const handleEditarAccionista = (obj,i) => {    
    setInfoModal(false);
    if(obj.prcCapital)
      obj.prcCapital=Number(obj.prcCapital);
    if(obj.aniosCargo)
      obj.aniosCargo=Number(obj.aniosCargo);
    setDataTemp(obj);
    setIndiceEditar(i);
  };

  const fillEditForm = (row)=> {
    console.log(row);
      
  };
  
  const handleCloseAddModal = () => {
    setOpenAdd(false);
  };

  const bodyModal = (tag) => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">{tag=='PEP'?'PEP (Persona Expuesta Politicamente)':'Informacion'}</h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <h4 className="title-07 margin-bottom-10 text-justify">
            {tag=='PEP'?`Personas expuestas políticamente (PEP): personas naturales, nacionales o extranjeras,
              que cumplen o que en los últimos cinco (5) años hayan cumplido funciones públicas destacadas 
              o funciones prominentes en una organización internacional, sea en el territorio nacional o extranjero,
              y cuyas circunstancias financieras puedan ser objeto de un interés público. Asimismo, 
              se considera como PEP al  colaborador directo de la máxima autoridad de la institución.`:''}
            
          </h4>
        </div>
      </div>
    );
  };
  const bodyModalAcc = (tag) => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10"><b>Accionistas, Socios o Asociados</b></h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          {data && data.accionista && data.accionista.length == 0 && (
            <div>No existen accionistas.</div>
          )}
          {data.accionista.map((obj,i)=>(
            <div className="rd--file-card padding-20">
              <div className="d-justify-space-between d-flex-column-m w100">
                <div className="documents_criteria_datos3">
                      <label>
                      <span className="title-06">
                        <b>{obj.idpTipoDocumento}: </b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.numeroDocumento}
                      </span>
                      </label>
                </div>
                <div className="documents_criteria_datos4">
                  <Button
                    className="padding-5"
                    size="small"
                    iconLeft={
                      <img
                        src={editUserIcon}
                        alt="edit user logo"
                        height={15}
                        className="margin-right-8"
                      />
                    }
                    onClick={() => handleEditarAccionista(obj, i)}
                  >
                    Editar
                  </Button>
                </div> 
              </div>
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Nombre o Razón Social: </b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.nombres} 
                      </span>
                      </label>
                </div>
                { obj.indPep && 
                  <div className="documents_criteria_datosmod">
                    <label>
                    <span className="title-06">
                      <b>PEP:</b>
                    </span>
                    <span className="title-06 title-lower">
                      {obj.indPep=='S'?'SI':'NO'}
                    </span>
                    </label>
                  </div>
                }
                { obj.prcCapital && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>% Capital:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.prcCapital}
                      </span>
                      </label>
                </div>
                }
                { obj.cargo && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Cargo:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.cargo}
                      </span>
                      </label>
                </div>
                }
                { obj.aniosCargo && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Años en que ejercio el cargo:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.aniosCargo}
                      </span> 
                      </label>
                </div>
                }
                { obj.fecNacimiento && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Fecha de Nacimiento:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.fecNacimiento}
                      </span>
                      </label>
                </div>
                }
                { obj.profesion && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Ocupación:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.profesion}
                      </span>
                      </label>
                </div>
                }
                { obj.idPais && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Nacionalidad:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {(arrPais && arrPais.length>0 && arrPais.find(el=>el.value==obj.idPais))?.text} 
                      </span>
                      </label>
                </div>
                }
                { obj.idResPais && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>País de Residencia:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {(arrPais && arrPais.length>0 && arrPais.find(el=>el.value==obj.idResPais))?.text} 
                      </span>
                      </label>
                </div>
                }
                { obj.direccion && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Dirección:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.direccion}
                      </span>
                      </label>
                </div>
                }
                { obj.telefono && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Teléfono:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.telefono}
                      </span> 
                      </label>
                </div>
                }
                { obj.correo && 
                <div className="documents_criteria_datosmod">
                      <label>
                      <span className="title-06">
                        <b>Correo:</b>
                      </span>
                      <span className="title-06 title-lower">
                        {obj.correo}
                      </span>
                      </label>
                </div>
                }                
            </div>
          ))}
        </div>
      </div>
    );
  };
    

  const handleSearchEndpoint = async () => {
    let payload = {
     
      
      
    };
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.searchArea,
      fetchObj
    );
    dispatch(hideLoading());
    if (response.ok && response.data) {
      let { totalPages } = response.data;
      setPaginationData({ ...paginationData, totalPages: totalPages });

      let arrData =
        response &&
        response.data &&
        response.data.rows &&
        response.data.rows.map((item) => {
          let obj = {
            id: item.ID,
            dateTimeCreation: item.dateTimeCreation,
            name: item.name,
            email: item.email,
            emailRecepcion: item.emailRecepcion,
            estado: item.estado,
            sendMailValidation:  item.sendMailValidation? item.sendMailValidation: false,
            valEmailRecepcion:  item.valEmailRecepcion? item.valEmailRecepcion: false  
          };
          return obj;
        });
    } else {
      console.log("Error fetching data => ", response.message);
      
    }
  };
  
  return (
    <div className="step__content" data-key={keyIndex}>
          <div className="proveedores_content">
              <h4 className="title-05 margin-bottom-16 margin-top-16">
                <b>Ingresa los <span class="title-red">Accionistas:</span></b>
              </h4>                  
              {/*<div className="d-justify-space-between d-flex-column-m w100">
                <div className="documents_criteria_datos">
                    <Input
                      label="Numero de partida electronica"
                      name="numPartidaElectronica"
                      maxLength="1000"
                      value={data?.numPartidaElectronica}
                      onChange={(newValue) => handleChange("numPartidaElectronica", newValue)}                        
                    />
                </div>
              </div>
              <div className="d-justify-space-between d-flex-column-m w100">
                <div className="documents_criteria_datos">                        
                    <InputWithDropdown
                      selectProps={{
                        label: "Moneda",
                        selected: data && arrMoneda.find(obj=>obj.value==data.idpMonedaCapital),                            
                        onChange: (newValue) =>
                          handleChange("idpMonedaCapital",  newValue.value),
                        items: arrMoneda,
                      }}
                      inputProps={{
                        label: "Monto de Capital Social",
                        name: "montoCapital",
                        maxLength: "15",
                        value: data?.montoCapital,
                        customRegex: /^[0-9]*$/,
                        onChange: (newValue) =>
                          handleChange("montoCapital", newValue)
                      }}
                    />
                </div>
              </div>*/}
              <div className="d-justify-space-between d-flex-column-m w100">
                {/*<div className="documents_criteria_datos">
                  <Checkbox 
                    id="indAccionista" 
                    label="¿Tienes accionistas, socios o asociados con participación directa o indirecta superior a 25% del capital, aporte o participación?" 
                    checked={data?.indAccionista=='S'}
                    onClick={(newValue) => handleChange("indAccionista", (newValue?'S':'N'))}
                    />                                         
                  </div>*/}
                <div className="documents_criteria_datos">
                      <p>¿Tienes accionistas, socios o asociados con participación directa o indirecta superior a 25% del capital, aporte o participación?</p>
                      <Radio
                          id="indAccionista"
                          name="indAccionista"
                          value="S"
                          onChange={(newValue) => handleChange("indAccionista", newValue)}
                          isChecked={data?.indAccionista}
                          hasError= {validacion.indAccionista && '*'} 
                      >
                          Si
                      </Radio>
                      <Radio
                          id="indAccionista"
                          name="indAccionista"
                          value="N"
                          onChange={(newValue) => {
                                                  data.indAccionista=newValue;
                                                  validacion.indAccionista=false;
                                                  handleChange("indAccionista", newValue);
                                                  handleChange("accionista", []);}} 
                          isChecked={data?.indAccionista}
                          hasError= {validacion.indAccionista && '*'}                           
                      >
                          No
                      </Radio>                            
                </div>
              </div>
              <div className="d-flex-center w100">
                <div className="documents_criteria_link">
                  <Button
                      size="small"
                      iconLeft={
                        <img
                          src={indVmAcc?chevrotIconUp:chevrotIconDown}
                          alt="ver mas logo"
                          height={12}
                          className="bg-blue margin-left-6 margin-right-8"
                        />
                      }
                      onClick={() => setIndVmAcc(!indVmAcc)}
                      text={indVmAcc?"Ver menos":"Ver mas"}
                    >                      
                  </Button> 
                </div>                
              </div>
              {indVmAcc &&
              <div className="d-justify-space-between d-flex-column-m w100 text-justify margin-bottom-10">
                <div className="documents_criteria_datos">
                  <div htmlFor="indAccionista2" className="padding-right-21 padding-left-21 padding-bottom-21">
                    Identificación de los accionistas, socios o asociados que tengan directa o indirectamente
                    mas de 25% del capital social, aporte o participacion de las personas juridica, nombre del 
                    representante legal, considerando la información requerida para las personas naturales y 
                    el grupo económico
                  </div>
                </div>                
              </div>
              }

              { data && data.indAccionista=='S' &&    
              <>
                <br/>
                <div className="d-justify-space-between d-flex-column-m w100 text-justify margin-bottom-10">
                  <div className="documents_criteria_datos">
                    <label htmlFor="indAccionista2">
                      Principales accionistas, socios o asociados (que tengan directa o indirectamente más del 25% del capital
                       social, aporte o participación) e indicar si es PEP en caso corresponda
                    </label>
                  </div>
                </div>
                <div className="d-justify-space-between d-flex-column-m w100">
                  <div className="documents_criteria_datos">
                      <InputWithDropdown
                        selectProps={{
                          label: "Tipo Documento",
                          selected: dataTemp && arrTipoDoc.find(obj=>obj.value==dataTemp.idpTipoDocumento),
                          onChange: (newValue) =>
                            handleChangeTemp("idpTipoDocumento",  newValue.value),
                          items: arrTipoDoc,
                          classNameList: 'listLarge',
                          hasError: validacionTemp.idpTipoDocumento && '*'
                        }}
                        inputProps={{
                          label: "Numero de Documento",
                          name: "numeroDocumento",
                          maxLength: "15",
                          value: dataTemp?.numeroDocumento,
                          customRegex: /^[a-zA-Z0-9]*$/,
                          onChange: (newValue) =>
                            handleChangeTemp("numeroDocumento", String(newValue)),
                          hasError: validacionTemp.numeroDocumento && '*'                          
                        }}
                      />
                  </div>
                </div>
                <div className="d-justify-space-between d-flex-column-m w100">
                  <div className="documents_criteria_datos">
                      <Input
                        label="Nombre Completo o Razón Social"
                        name="nombres"
                        maxLength="500"
                        value={dataTemp?.nombres}
                        onChange={(newValue) => {
                          handleChangeTemp("nombres", newValue); 
                        }                        
                        }
                        hasError= {validacionTemp.nombres && '*'}
                        customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}                      
                      />
                  </div>
                </div>
                {(dataTemp && (dataTemp.idpTipoDocumento=='RUC' || dataTemp.idpTipoDocumento=='DOT'))?
                 (<div className="d-justify-space-between d-flex-column-m w100">
                    <div className="documents_criteria_datos">
                        <Input
                          label="% Participación accionarial"
                          name="prcCapital"
                          maxLength="3"
                          value={dataTemp?.prcCapital}
                          onChange={(newValue) => {
                            handleChangeTemp("prcCapital", Number(newValue)); 
                          }                          
                          }
                          hasError= {validacionTemp.prcCapital && '*'}
                          customRegex={/^[0-9]*$/}                       
                        />
                    </div>
                  </div>):
                  (<div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                          <InputWithDropdown
                            selectProps={{
                              label: "PEP",
                              selected: dataTemp && arrSN.find(obj=>obj.value==dataTemp.indPep),
                              onChange: (newValue) =>
                                handleChangeTemp("indPep",  newValue.value),
                              items: arrSN,
                              hasError: validacionTemp.indPep && '*'
                            }}
                            inputProps={{
                              label: "% Participación accionarial",
                              name: "prcCapital",
                              maxLength: "3",
                              value: dataTemp?.prcCapital,
                              customRegex: /^[0-9]*$/,
                              onChange: (newValue) =>
                                handleChangeTemp("prcCapital", Number(newValue)),
                              hasError: validacionTemp.prcCapital && '*'
                            }}
                          />
                      </div>
                    </div>)
                }
                {(dataTemp && (dataTemp.idpTipoDocumento!='RUC' && dataTemp.idpTipoDocumento!='DOT' && dataTemp.idpTipoDocumento)) && 
                 <>
                    {dataTemp.indPep=='S' && 
                      <div className="d-justify-space-between d-flex-column-m w100">
                        <div className="documents_criteria_datos2">
                            <Input
                              label="Cargo"
                              name="cargo"
                              maxLength="500"
                              value={dataTemp?.cargo}
                              onChange={(newValue) => {
                                handleChangeTemp("cargo", newValue); 
                              }
                              }
                              hasError= {validacionTemp.cargo && '*'}
                              customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}                        
                            />
                        </div>
                        <div className="documents_criteria_datos2">
                            <Input
                              label="Años en los que ejercio el cargo (indicar si sigue teniendo el cargo)"
                              name="aniosCargo"
                              maxLength="4"
                              value={dataTemp?.aniosCargo}
                              onChange={(newValue) => {
                                handleChangeTemp("aniosCargo", Number(newValue)); 
                              }
                              }
                              hasError= {validacionTemp.aniosCargo && '*'}
                              customRegex={/^[0-9]*$/}
                            />
                        </div>
                      </div>
                    }                    
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                        <InputPicker
                        label="Fecha Nacimiento"
                        // value={data?.initDate}
                        value={dataTemp?.fecNacimiento ? (moment(dataTemp.fecNacimiento,"DD-MM-YYYY").toDate()):(undefined)}
                        onChange={(objDate) => handleChangeTemp("fecNacimiento", objDate.value?moment(objDate.value).format("DD-MM-YYYY"):'')}
                        maxDate={new Date()}
                        hasError= {validacionTemp.fecNacimiento && '*'}
                      />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                          <Input
                            label="Ocupación/Profesión"
                            name="profesion"
                            maxLength="1000"
                            value={dataTemp?.profesion}
                            onChange={(newValue) => {
                              handleChangeTemp("profesion", newValue); 
                            }
                            }
                            hasError= {validacionTemp.profesion && '*'}
                            customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}                      
                          />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                        <Select
                          label="Nacionalidad"
                          selected={dataTemp && arrPais.find(obj=>obj.value==dataTemp.idPais)}
                          onChange={(newValue) => {handleChangeTemp("idPais", newValue.value);
                                                  }}
                          items={arrPais}
                          filterable = {true}
                          hasError= {validacionTemp.idPais && '*'}
                        />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                        <Select
                          label="País de Residencia"
                          selected={dataTemp && arrPais.find(obj=>obj.value==dataTemp.idResPais)}
                          onChange={(newValue) => {handleChangeTemp("idResPais", newValue.value);
                                                  }}
                          items={arrPais}
                          filterable = {true}
                          hasError= {validacionTemp.idResPais && '*'}
                        />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                          <Input
                            label="Dirección"
                            name="direccion"
                            maxLength="500"
                            value={dataTemp?.direccion}
                            onChange={(newValue) => {
                              handleChangeTemp("direccion", newValue); 
                            }
                            }
                            hasError= {validacionTemp.direccion && '*'}
                            customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}                        
                          />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                          <Input
                            label="Teléfono"
                            name="telefono"
                            maxLength="15"
                            value={dataTemp?.telefono}
                            onChange={(newValue) => {
                              handleChangeTemp("telefono", newValue); 
                            }
                            }
                            hasError= {validacionTemp.telefono && '*'}
                            customRegex={/^[0-9]*$/}                        
                          />
                      </div>
                    </div>
                    <div className="d-justify-space-between d-flex-column-m w100">
                      <div className="documents_criteria_datos">
                          <Input
                            label="Correo"
                            name="correo"
                            maxLength="1000"
                            value={dataTemp?.correo}
                            onChange={(newValue) => {
                              handleChangeTemp("correo", newValue); 
                            }
                            }
                            hasError= {validacionTemp.correo && '*'}
                            customRegex={/^[a-zA-Z0-9\.\-\_@\.]*$/}                        
                          />
                      </div>
                    </div>
                 </>
                }                
                
                <div className="d-flex-center w100">
                  <div className="documents_criteria_btns d-flex-end margin-bottom-16">
                    <div className="documents_btnSearch">
                      <Button
                        // type="submit"
                        primary
                        size="small"
                        onClick={()=>
                                {if(validarFormulario())
                                  { if(indiceEditar==null || indiceEditar==undefined){
                                      data.accionista.push(dataTemp);
                                    }else{
                                      data.accionista[indiceEditar]=dataTemp;
                                    }
                                    setIndiceEditar(null);                                   
                                    setDataTemp({});
                                    handleChange("accionista", data.accionista,data.accionista.length-1 ); 
                                  }
                                }
                        }
                      >
                        Agregar Socio
                      </Button>
                    </div>                  
                  </div>
                </div>
              </>
              }

              <div className="d-justify-space-between d-flex-column-m w100">
                <div className="documents_criteria_btns d-flex-end margin-bottom-16">
                  <div className="documents_btnSearch">
                    <Button
                      // type="submit"
                      primary
                      size="large"
                      onClick={()=>{
                        if(validarFormularioGeneral()){
                          if(data.accionista.length>0 || data.indAccionista=='N'){
                            handleActualizarFicha(data);
                            handleChangePaso(keyIndex);
                          }else{
                            let valTemp={idpTipoDocumento: true,
                                            numeroDocumento: true,
                                            nombres: true,
                                            indPep: true,
                                            cargo: true,
                                            prcCapital: true,
                                            aniosCargo: true,
                                            idPais: true,  
                                            idResPais: true,    
                                            fecNacimiento: true,
                                            profesion: true,
                                            direccion: true,
                                            telefono: true,
                                            correo: true};
                            setValidacionTemp({...valTemp});
                          }
                        }
                      }}
                    >
                      Continuar
                    </Button>
                  </div>                  
                </div>
              </div>
          </div>
          <div className="proveedores_margen">
              <DatosProveedor data={dataT}/>
              <div className="documents_criteria_datos">
                  <Button
                    size="small"
                    
                    onClick={() => handleShowModal("PEP")}
                  >
                    ¿Ques es PEP?
                  </Button>
              </div>
              <div className="documents_criteria_datos">
                  <label htmlFor="indAccionista2">
                    Agregaste {data.accionista.length} accionistas, socios o asociados.
                  </label>                      
                  <Button
                    size="small"
                    iconLeft={
                      <img
                        src={addUserIcon}
                        alt="add user logo"
                        height={15}
                        className="margin-right-8"
                      />
                    }
                    onClick={() => handleShowModal("ACC")}
                  >
                    VER ACCIONISTAS
                  </Button>                    
              </div>      
          </div>

            <Modal
                className="rd--modal-info-files"
                onToggle={(value) => setInfoModal(false)}
                visible={infoModal}
                width={672}
                fullScreenMobile
                redHoverClosed
                onLabelClosed
                max12Padding
                footer={
                  <Button primary onClick={() => setInfoModal(false)}>
                    Cerrar
                  </Button>
                }
              >
                {tagBody!='PEP'?bodyModalAcc():bodyModal(tagBody)}
            </Modal>
            
      </div>
  );
};


export default ProveedoresAccionista;
